import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as AssetLevel from 'asset_level/components';
import AssetLevelListHandlers from 'asset_level/containers/AssetLevelListHandlers';
import AssetLevelRowContainer from 'asset_level/containers/AssetLevelRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleAssetLevel,
  getIsLoading,
  getNeedFetch,
} from 'asset_level/selectors';
import { toggleAssetLevel } from 'asset_level/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class AssetLevelListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };
  handleToggle = (id) =>
    this.props
      .toggleAssetLevel(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <AssetLevelListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <AssetLevel.ListView
          count={this.props.asset_level.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.asset_level.map((asset_level) => (
            <AssetLevelRowContainer
              key={asset_level.id}
              asset_level={asset_level}
              handleToggle={this.handleToggle}
            />
          ))}
        </AssetLevel.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  asset_level: getVisibleAssetLevel(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { toggleAssetLevel, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(AssetLevelListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/containers/AssetLevelListContainer.js